import { render } from "./YouthUnemploy.vue?vue&type=template&id=047ecb1d&ts=true"
import script from "./YouthUnemploy.vue?vue&type=script&lang=ts"
export * from "./YouthUnemploy.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__